import { TitleSizes, TitleVariants } from "./constants";
import styled, { css } from "styled-components";
import { Contrast } from "../../../types/general.types";
import { ids } from "@icarros/theme-react";
const { text, color } = ids || {};
const defaultStyle = css `
  color: ${color.text.heading.ids_color_text_heading_01};
`;
const highlight = css `
  color: ${color.text.highlight.ids_color_text_highlight};
`;
const onLight = css `
  color: ${color.contrast.ids_color_contrast_onLight};
`;
const onDark = css `
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const base = { ...text.head.ids_textStyle_title_01_base };
const variant = { ...text.head.ids_textStyle_title_01_variant };
const overline = { ...text.head.ids_textStyle_overline };
const getTitleSizeStyle = (size) => {
    switch (size) {
        case TitleSizes.base:
            return base;
        case TitleSizes.variant:
            return variant;
        case TitleSizes.overline:
            return overline;
        default:
            return base;
    }
};
const getTitleKindStyle = (variant, contrast) => {
    if (contrast === Contrast.dark)
        return onDark;
    if (contrast === Contrast.light)
        return onLight;
    switch (variant) {
        case TitleVariants.default:
            return defaultStyle;
        case TitleVariants.highlight:
            return highlight;
        default:
            return defaultStyle;
    }
};
const StyledTitle = styled.div `
  ${({ size }) => getTitleSizeStyle(size)}
  ${({ variant, contrast }) => getTitleKindStyle(variant, contrast)}
`;
export default StyledTitle;
//# sourceMappingURL=Title.style.js.map